(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-bet-placed.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-bet-placed.js');
"use strict";


svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_betPlaced = (_, internals) => () => {
  internals.lastBetPlacedTimestamp = Date.now();
};

 })(window);